import { useEffect, useState } from "react";
import { type DeviceInfo, getDeviceInfo } from "@akina/infra";

export const useGetDeviceInfo = () => {
  const [deviceInfo, setDeviceInfo] = useState<DeviceInfo | null>(null);
  const [parsedDeviceInfo, setParsedDeviceInfo] = useState<string>("");

  useEffect(() => {
    const fetchDeviceInfo = async () => {
      const [deviceInfo, parsedDeviceInfo] = await getDeviceInfo();
      setDeviceInfo(deviceInfo);
      setParsedDeviceInfo(parsedDeviceInfo);
    };

    fetchDeviceInfo();
  }, []);

  return { deviceInfo, parsedDeviceInfo };
};
